import { gql, useMutation } from "@apollo/client"
import cx from "classnames"
import LazyLoad from "./LazyLoad"
import PlayIcon from "../../icons/PlayIcon"
import styles from "../styles/Mixtape.module.scss"
import spinnerStyles from "../styles/spinners.module.scss"
import MarmosetIcon from "../../icons/MarmosetIcon"

const PLAY_MIXTAPE = gql`
  mutation PlayMixtape($id: ID!) {
    playMixtape(id: $id) {
      songVersions {
        id
        customizable
        displayName
        exclusive
        hasClickLicenses
        length
        lyrics
        playerArt
        songVersionFile
        artist {
          id
          name
        }
      }
    }
  }
`

const Mixtape = ({ id, name, slug, imageUrl, cutoutShape }) => {
  const [playMixtape, { loading }] = useMutation(PLAY_MIXTAPE)

  const shapeMap = {
    "triangle": styles.cutoutTriangle,
    "circle": styles.cutoutCircle,
    "topBar": styles.cutoutTopBar,
    "none": ""
  }

  const handlePlayMixtape = (e) => {
    e.preventDefault()
    e.stopPropagation()
    // If mobile audio element is already playing, pause it
    var audioElement = $('audio[src^="/song_versions/play/"]')
    if (audioElement.length > 0) {
      if (!audioElement[0].paused) {
        audioElement[0].pause()
        return
      }
    }
    const variables = { id }
    playMixtape({ variables })
      .then(({ data: { playMixtape } }) => {
        const playlistEvent = new CustomEvent("load-playlist", {
          detail: { items: playMixtape.songVersions.map((sv) => JSON.parse(sv.playSerializer)) },
        })
        document.dispatchEvent(playlistEvent)
        const songVersionDetail = {
          detail: JSON.parse(playMixtape.songVersions[0].playSerializer),
        }
        const playEvent = new CustomEvent("start-playlist", songVersionDetail)
        document.dispatchEvent(playEvent)
      })
      .catch((err) => console.log(err))
  }

  return (
    <div
      className={cx("lazy", styles.mixtape)}
    >
        <div 
            className={cx(styles.cutoutGradient, shapeMap[cutoutShape])}
          >
        </div>
      <LazyLoad>
        <div 
          className={cx("lazy", styles.mixtapeImage, shapeMap[cutoutShape])} 
          data-style={`background: url(${imageUrl}) center center / cover no-repeat;`}>
        </div>
      </LazyLoad>
      <div className={cx(styles.overlay)}>
      </div>
      <a href={`/playlists/${slug}`} data-turbo="true" data-turbo-frame="_top" className={styles.nameWrapper}>
        <h3 className={"hThree"}>{name}</h3>
      </a>
      <div className={cx(styles.actions, shapeMap[cutoutShape])}>
        {loading ? (
          <div className={spinnerStyles.mediumSpinner} />
        ) : (
          <a onClick={handlePlayMixtape}>
            <PlayIcon />
          </a>
        )}
        <div className={styles.more}>
          <MarmosetIcon />
        </div>
      </div>
    </div>
  )
}

export default Mixtape
